import React, { useEffect, useState } from 'react'
// import SimpleTable from './SimpleTable'
// import PaginationTable from './PaginationTable'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import MuiPhoneNumber from 'material-ui-phone-number'
import TextField from '@mui/material/TextField'
import { useSearchParams } from 'react-router-dom'
import { Apis } from 'app/Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import axios from 'axios'
import { StaticData } from 'app/utils/constant'
import { makeStyles } from '@mui/styles'
const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const ProfileCard = () => {
    const [profileData, setProfileData] = useState()
    const [searchParams] = useSearchParams()
    const imageUrl = profileData?.image || StaticData?.profileImage

    const roleId = searchParams.get('_id')
    let config = {
        headers: {
            Authorization: `Bearer ${AuthToken.LOCAL_STORAGE_STABLE_ID}`,
        },
    }
    const singleRole = async () => {
        await axios
            .get(`${Apis.getSingleRole}/${roleId}`, config)
            .then((res) => {
                setProfileData(res?.data?.data)
            })
            .catch(() => {})
    }

    useEffect(() => {
        singleRole()
    }, [])

    return (
        <Container>
            <Box py="px" />
            <SimpleCard title="">
                <Box
                    sx={{
                        borderBottom: 'solid',
                        borderColor: 'grey.200',
                        marginBottom: 5,
                        fontWeight: 500,
                        fontSize: 20,
                    }}
                >
                    {profileData?.role === 'doctor'
                        ? 'Doctor details'
                        : 'User details'}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            borderBottom: 'solid',
                            borderColor: 'grey.200',
                            width: '110%',
                        }}
                    >
                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Name</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {profileData?.name}
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Userame</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',

                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {profileData?.username}
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Email</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                <Box>{profileData?.email}</Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Phone</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {profileData?.mobilenumber}
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Role</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {profileData?.role}
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Address</Box>{' '}
                            <Box
                                sx={{
                                    width: '70%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {profileData?.address}
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', paddingBottom: '2rem' }}>
                            <Box sx={{ width: '30%' }}>Profile image</Box>{' '}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                    alignItems: 'center',
                                    width: '50%',
                                }}
                            >
                                <img
                                    src={imageUrl || StaticData.profileImage}
                                    alt=""
                                    style={{
                                        width: '75px',
                                        height: '75px',
                                        position: 'relative',
                                        borderRadius: '50px',
                                        left: '2%',
                                    }}
                                />
                                <input
                                    type="file"
                                    id="avatarUpload"
                                    style={{ display: 'none' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </SimpleCard>

            <Link
                style={{ position: 'relative', top: '10px' }}
                to={'/dashboard/doctorlist'}
            >
                <Button variant="contained">Back</Button>
            </Link>
        </Container>
    )
}

export default ProfileCard
